// Adresse publique d'un profil : /profile/@pseudo si un pseudo existe, sinon /profile/<id>.
export const profilePath = ({ id, username }: { id: string; username?: string | null }) =>
  username ? `/profile/@${encodeURIComponent(username)}` : `/profile/${id}`;
